export const number = (value: number, maximumFractionDigits?: number) =>
  typeof value === 'number' ? value.toLocaleString(undefined, { maximumFractionDigits }) : value;
